import { useMemo } from "react";
import { motion } from "framer-motion";

// Dezent fallende Herbstblätter im Hintergrund – passend zum Igel im Herbst.
// SVG-Blätter in den Brandfarben, langsam und sanft.

const LEAF_PATHS = [
  // einfaches Blatt
  "M12 2c4 3 7 7 7 11 0 4-3 7-7 9-4-2-7-5-7-9 0-4 3-8 7-11z",
];

function Leaf({ color }) {
  return (
    <svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true">
      <path d={LEAF_PATHS[0]} fill={color} />
      <path d="M12 3v18" stroke="rgba(0,0,0,0.12)" strokeWidth="0.6" fill="none" />
    </svg>
  );
}

export default function FallingLeaves({ count = 9 }) {
  const colors = ["#F28F3B", "#E06A88", "#6B9071", "#D98236", "#C9557A"];

  const leaves = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const size = 16 + Math.random() * 22;
      return {
        id: i,
        left: Math.random() * 100,
        size,
        color: colors[i % colors.length],
        duration: 16 + Math.random() * 14,
        delay: Math.random() * 14,
        drift: (Math.random() - 0.5) * 120,
        rotate: 180 + Math.random() * 360,
      };
    });
  }, [count]);

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-[5] overflow-hidden"
      data-testid="falling-leaves"
    >
      {leaves.map((leaf) => (
        <motion.div
          key={leaf.id}
          className="absolute top-[-8%]"
          style={{ left: `${leaf.left}%`, width: leaf.size, height: leaf.size, opacity: 0.55 }}
          initial={{ y: "-10vh", x: 0, rotate: 0 }}
          animate={{
            y: "112vh",
            x: [0, leaf.drift, -leaf.drift * 0.5, leaf.drift * 0.3, 0],
            rotate: leaf.rotate,
          }}
          transition={{
            duration: leaf.duration,
            delay: leaf.delay,
            repeat: Infinity,
            ease: "linear",
          }}
        >
          <Leaf color={leaf.color} />
        </motion.div>
      ))}
    </div>
  );
}
